import { render } from "./BidangBudidaya.vue?vue&type=template&id=194d02a7"
import script from "./BidangBudidaya.vue?vue&type=script&lang=js"
export * from "./BidangBudidaya.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__